import { zxcvbnOptions } from '../../Options';
export default (match) => {
    if (match.regexName === 'recentYear') {
        return {
            warning: zxcvbnOptions.translations.warnings.recentYears,
            suggestions: [
                zxcvbnOptions.translations.suggestions.recentYears,
                zxcvbnOptions.translations.suggestions.associatedYears,
            ],
        };
    }
    return {
        warning: null,
        suggestions: [],
    };
};
//# sourceMappingURL=feedback.js.map